import { MatchIdType } from 'components/powerFlowShared/components/modals/filters/criteriaFields';
import { MatchingOperator } from 'components/powerFlowShared/components/types';
export const validate = (values) => {
    var _a, _b;
    const errors = {};
    if (!((_a = values.rules) === null || _a === void 0 ? void 0 : _a.length))
        return errors;
    if (!((_b = values.description) === null || _b === void 0 ? void 0 : _b.trim())) {
        errors.description = 'Adding a description is required';
    }
    const ruleErrors = [];
    values.rules.forEach(({ variable, match, matching_rule, variableType }, index) => {
        const ruleError = {};
        if (!(variable === null || variable === void 0 ? void 0 : variable.trim())) {
            ruleError.variable = 'Please select an item for this filter';
        }
        if (!(variable === null || variable === void 0 ? void 0 : variable.trim()) ||
            (!match &&
                ![MatchingOperator.IS_EMPTY, MatchingOperator.IS_NOT_EMPTY].includes(matching_rule))) {
            ruleError.match =
                'Add a second item so this filter can sort conversations';
        }
        if (variableType === MatchIdType.DateRange) {
            if (match &&
                (!Object.keys(match).length ||
                    !!Object.entries(match).find(([, value]) => !value))) {
                ruleError.match =
                    'Add a date range so this filter can sort conversations';
            }
        }
        if (Object.keys(ruleError).length) {
            ruleErrors[index] = ruleError;
        }
    });
    errors.rules = ruleErrors;
    return errors;
};
